import { StreamLanguage, StreamParser, HighlightStyle, syntaxHighlighting } from "@codemirror/language";
import { tags } from "@lezer/highlight";
import { RQL_OPERATORS } from "../../utils/equationParser";

// Operator names are matched case-sensitively, mirroring EquationParser's own exact-case
// operatorPattern — the highlighter must never accept something the parser would reject as an
// operator, or the two would visually disagree about what's a keyword.
const OPERATOR_REGEX = new RegExp(`^(${RQL_OPERATORS.join("|")})\\b`);

interface IRqlParserState {}

const rqlStreamParser: StreamParser<IRqlParserState> = {
  token(stream) {
    if (stream.eatSpace()) {
      return null;
    }

    if (stream.match('"') || stream.match("'")) {
      const quote = stream.string[stream.pos - 1];
      while (!stream.eol()) {
        const next = stream.next();
        if (next === quote) {
          break;
        }
      }
      return "string";
    }

    if (stream.match(OPERATOR_REGEX)) {
      return "keyword";
    }

    if (stream.match(/^[(),]/)) {
      return null;
    }

    // Bare identifier run (question/response variable or rank name) — not lexically
    // distinguishable from each other by the grammar alone, so it's left uncolored here; a
    // future data-aware decoration pass (cross-checking against the live variable/rank lists
    // already threaded into the autocomplete sources) is what would color these, not this
    // static tokenizer.
    if (!stream.eatWhile(/[^\s(),"']/)) {
      stream.next();
    }
    return null;
  },
  startState() {
    return {};
  },
  tokenTable: {
    keyword: tags.keyword,
    string: tags.string,
  },
};

export const rqlLanguage = StreamLanguage.define(rqlStreamParser);

const rqlHighlightStyle = HighlightStyle.define([
  { tag: tags.keyword, color: "var(--mnq-accessibility-bg)", fontWeight: "600" },
  { tag: tags.string, color: "var(--mnq-accessibility-bg)" },
]);

export const rqlHighlighting = syntaxHighlighting(rqlHighlightStyle);
